// extracted by mini-css-extract-plugin
export default {"root":"_1g-wk","animator":"TmdU0","notification-link":"_3sycH","notificationLink":"_3sycH"};